import { usePortletConfig, withPortlet } from 'js/components/system/Portlet';
import { componentService } from 'js/services/component.service';
import { groupBy, prop } from 'ramda';
import React, { useState, useRef, useEffect } from 'react';
import { branch, compose, renderComponent, withProps } from 'recompose';
import CloseOverlay from '../common/CloseOverlay';
import { withEmptyState } from '../common/EmptyState';
import FadeInContainer from '../common/FadeInContainer';
import { WidgetsHeader } from '../common/WidgetsHeader/WidgetsHeader';
import { TopHeader } from '../common/TopHeader';
import { DiscoveryCategoryHeaderBanner } from '../common/DiscoveryCategoryHeaderBanner/DiscoveryCategoryHeaderBanner';
import { CASINO_LEADER_BOARD_RACES_LIST } from './constants';
import style from './index.scss';
import ListSlider from './ListSlider';
import Skeleton from './Skeleton';
import withMixedLeaderBoardList from './withMixedLeaderBoardList';
import withSortedList from './withSortedList';
import withTabs from './withTabs';
import { getLocationParam } from 'js/utils/url.util';
import { publicEventsAPIService } from '@core/js/services/publicEventsAPI.service';
import { useCommonProperties } from './analytics/useCommonProperties';
import classNames from 'js/components/main/CasinoLeaderBoard/Details/classNames';

export const RacesListMobile = ({ leaderboards, tabs, ...rest }) => {
    const { useTournament } = rest;

    const pwMapping = {
        mp: 'mysteryParcel',
        lb: 'leaderboards',
        missions: 'missions'
    };

    const mixPanelEventTypeMapping = {
        mysteryParcel: 'Mystery Parcel',
        leaderboards: 'Leaderboards',
        missions: 'Missions'
    };

    const categoryKeyToMixPanelMapping = {
        discoveryCompleted: 'completed',
        discoveryFinished: 'finished',
        discoveryComingSoon: 'comming soon',
        discoveryAvailable: 'available',
        discoveryActive: 'active'
    };

    const commonProperties = useCommonProperties();
    const mixPanelTrackCallback = (eventName, key) => {
        publicEventsAPIService.trigger(eventName, {
            ...commonProperties, ...{
                section: categoryKeyToMixPanelMapping[key],
                engagementEventType: mixPanelEventTypeMapping[activeTab]
            }
        });
    };

    const [presentTabs, setIsParcelPresent] = useState({ isParcelPresent: false, isLbPresent: false, isMissionsPresent: false });

    useEffect(() => {
        detectAvailableWidgetsOnUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leaderboards]);

    const computeInitialTab = () => {
        let previousActive;
        let isMPP = false;
        let isLbP = false;
        let isMisP = false;
        const pw = getLocationParam('pw');
        if (pw && pw !== 'undefined') {
            previousActive = pwMapping[pw];
        }
        const newlbs = flatten(reassembleArrayFromObj(leaderboards));
        const forSort = newlbs.map(e => {
            if (e.isParcel) {
                isMPP = true;
            }
            if (e.leaderboardId && e.missions) {
                isMisP = true;
            }
            if (e.leaderboardId && !e.missions) {
                isLbP = true;
            }
            if (e.status === 'ACTIVE' && e.joined) {
                e.sortValue = 11;
            } else if (e.status === 'ACTIVE' && !e.joined) {
                e.sortValue = 10;
            } else if (e.status === 'NOT_STARTED' && e.joined) {
                e.sortValue = 9;
            } else if (e.status === 'NOT_STARTED' && !e.joined) {
                e.sortValue = 8;
            } else if (e.eventCount && e.eventCount === e.eventCountLimit && e.joined) {
                e.sortValue = 7;
            } else if (e.eventCount && e.eventCount === e.eventCountLimit && !e.joined) {
                e.sortValue = 6;
            } else if (e.status === 'PENDING_REVIEW' || e.status === 'COMPLETED') {
                e.sortValue = 5;
            } else {
                e.sortValue = 0;
            }
            return e;
        });
        forSort.sort((board1, board2) => {
            if (board1.sortValue > board2.sortValue) {
                return -1;
            } else if (board1.sortValue < board2.sortValue) {
                return 1;
            }
                if (board1.sortValue === 11 || board1.sortValue === 10 ||
                    board1.sortValue === 6 || board1.sortValue === 7) {
                    if (board1.millisecondsTillLeaderboardEnd >= board2.millisecondsTillLeaderboardEnd) {
                        return 1;
                    }
                        return -1;

                } else if (board1.sortValue === 9 || board1.sortValue === 8) {
                    if (board1.millisecondsTillLeaderboardStart >= board2.millisecondsTillLeaderboardStart) {
                        return 1;
                    }
                        return -1;

                } else if (board1.sortValue === 5) {
                    if (board1.eventEndTime >= board2.eventEndTime) {
                        return -1;
                    }
                        return 1;

                }
                return 0;

        });
        setIsParcelPresent({ isParcelPresent: isMPP, isLbPresent: isLbP, isMissionsPresent: isMisP });
        if (previousActive === 'leaderboards' && isLbP ||
            previousActive === 'mysteryParcel' && isMPP ||
            previousActive === 'missions' && isMisP) {
            return previousActive;
        }
        const firstBoard = forSort[0];
        if (!firstBoard) {
            if (isLbP) {
                return 'leaderboards';
            } else if (isMPP) {
                return 'mysteryParcel';
            }
            return 'missions';
        }
        if (firstBoard.isParcel) {
            return 'mysteryParcel';
        } else if (firstBoard.missions) {
            return 'missions';
        }
        return 'leaderboards';
    };

    const detectAvailableWidgets = (activeTab) => {
        let isPP = false;
        let isLbP = false;
        let isMisP = false;
        if (activeTab === 'mysteryParcel') {
            isPP = true;
        } else if (activeTab === 'leaderboards') {
            isLbP = true;
        } else if (activeTab === 'missions') {
            isMisP = true;
        }
        flatten(reassembleArrayFromObj(leaderboards))
            .forEach(e => {
                if (e.isParcel) {
                    isPP = true;
                }
                if (e.leaderboardId && e.missions) {
                    isMisP = true;
                }
                if (e.leaderboardId && !e.missions) {
                    isLbP = true;
                }
            }
        );
        setIsParcelPresent({ isParcelPresent: isPP, isLbPresent: isLbP, isMissionsPresent: isMisP });
    };

    const detectAvailableWidgetsOnUpdate = () => {
        let isPP = false;
        let isLbP = false;
        let isMisP = false;
        flatten(reassembleArrayFromObj(leaderboards))
            .forEach(e => {
                if (e.isParcel) {
                    isPP = true;
                }
                if (e.leaderboardId && e.missions) {
                    isMisP = true;
                }
                if (e.leaderboardId && !e.missions) {
                    isLbP = true;
                }
            }
        );
        if (activeTab === 'mysteryParcel' && !isPP ||
            activeTab === 'leaderboards' && !isLbP ||
            activeTab === 'missions' && !isMisP) {
            return;
        }
        setIsParcelPresent({ isParcelPresent: isPP, isLbPresent: isLbP, isMissionsPresent: isMisP });
    };

    const [activeTab, setActiveTab] = useState(() => computeInitialTab());
    const content = useRef(null);

    const onActiveTabClicked = (currentActiveTab) => {
        if (activeTab !== currentActiveTab) {
            setActiveTab(currentActiveTab);
            detectAvailableWidgets(currentActiveTab);
        }
    };

    const modLBs = filterBoards(activeTab, flatten(reassembleArrayFromObj(leaderboards)));

    return (
        <FadeInContainer className={classNames(style.direction, style.container)}>
            <div className={style.fixedContainer}>
                <TopHeader />
                <WidgetsHeader presentTabs={presentTabs} useTournament={useTournament} initialActiveTabName={activeTab}
                               onActiveTabClick={(clickedTab) => onActiveTabClicked(clickedTab)}/>
                <div ref={content} className={style.raceList}>
                    { Object.keys(modLBs.boards)
                        .filter((key) => key !== 'discoveryCompleted')
                        .map((key, index) => {
                            return (
                                <div key={`div${key}${index}`}>
                                    <DiscoveryCategoryHeaderBanner activeTab={activeTab}
                                                                   state={key} translationKey={key}
                                                                   counter={modLBs.boards[key].length}
                                                                   mixPanelTrackCallback={mixPanelTrackCallback}>
                                        <ListSlider leaderboards={modLBs.boards[key]}
                                            boardLength={modLBs.lengths[key]} {...modLBs.boards[key]} {...rest} />
                                    </DiscoveryCategoryHeaderBanner>
                                </div>);
                    })}
                </div>
            </div>
            <CloseOverlay />
        </FadeInContainer>
    );
};

const reassembleArrayFromObj = object => Object.keys(object).map(k => object[k]);

const flatten = (array, d) => {
    let depth = d;
    if (depth === undefined) {
        depth = Infinity;
    }
    return array.flat(depth);
};

const filterBoards = (activeTab, leaderboards) => {
    const modifiedLeaderboards = {
        boards: {
            discoveryActive: [],
            discoveryAvailable: [],
            discoveryComingSoon: [],
            discoveryFinished: [],
            discoveryCompleted: []
        },
        lengths: {
            discoveryActive: 0,
            discoveryAvailable: 0,
            discoveryComingSoon: 0,
            discoveryCompleted: 0,
            discoveryFinished: 0
        }
    };

    const widgetsAccordingToTab = leaderboards.filter((board) => {
        if (board.isParcel && activeTab === 'mysteryParcel' ||
            !board.isParcel && activeTab === 'leaderboards' && !board.missions ||
            !board.isParcel && activeTab === 'missions' && board.missions) {
            return true;
        }
        return false;
    });

    modifiedLeaderboards.boards.discoveryActive = widgetsAccordingToTab.filter((board) => {
        if (board.eventCount) {
            return board.status === 'ACTIVE' && board.joined && board.eventCount < board.eventCountLimit;
        }
        return board.status === 'ACTIVE' && board.joined;
    })
        .sort((a, b) => a.millisecondsTillLeaderboardEnd - b.millisecondsTillLeaderboardEnd);

    modifiedLeaderboards.boards.discoveryAvailable = widgetsAccordingToTab.filter(board => board.status === 'ACTIVE' && !board.joined)
        .sort((a, b) => a.millisecondsTillLeaderboardEnd - b.millisecondsTillLeaderboardEnd);

    modifiedLeaderboards.boards.discoveryComingSoon = widgetsAccordingToTab.filter(board => board.status === 'NOT_STARTED')
        .sort((a, b) => a.millisecondsTillRegistrationEnd - b.millisecondsTillRegistrationEnd);

    modifiedLeaderboards.boards.discoveryCompleted = widgetsAccordingToTab.filter((board) => {
        if (board.eventCount) {
            return board.status === 'ACTIVE' && board.joined && board.eventCount >= board.eventCountLimit;
        }
        return false;
    })
        .sort((a, b) => a.millisecondsTillLeaderboardEnd - b.millisecondsTillLeaderboardEnd);

    modifiedLeaderboards.boards.discoveryFinished = widgetsAccordingToTab.filter(board => board.status === 'PENDING_REVIEW' || board.status === 'COMPLETED').map((board) => {
        board.timeSinceEnd = new Date() - new Date(board.leaderboardEndTime);
        return board;
    })
        .sort((a, b) => a.timeSinceEnd - b.timeSinceEnd);

    modifiedLeaderboards.boards.discoveryFinished = [
        ...modifiedLeaderboards.boards.discoveryCompleted,
        ...modifiedLeaderboards.boards.discoveryFinished
    ];

    Object.keys(modifiedLeaderboards.boards).map((key) => {
        modifiedLeaderboards.boards[key] = modifiedLeaderboards.boards[key].map((board) => {
            if (key === 'discoveryFinished') {
                board.fakeState = board.status === 'ACTIVE' ? 'discoveryCompleted' : 'discoveryFinished';
            } else {
                board.fakeState = key;
            }
            return board;
        });
        modifiedLeaderboards.lengths[key] = modifiedLeaderboards.boards[key].length;
        return key;
    });

    return modifiedLeaderboards;
};

export const RacesList = compose(
    withPortlet({ forLoggedIn: true }),
    withProps(() => {
        const config = usePortletConfig();
        return {
            ...config,
            presentEndedRaces: true,
            presentPendingRaces: true
        };
    }),
    withMixedLeaderBoardList,
    branch(
        ({ leaderboards, error }) => !leaderboards && !error,
        renderComponent(Skeleton)
    ),
    withEmptyState,
    withSortedList,
    withProps(
        ({ leaderboards: lbs }) => {
            const leaderboards = groupBy(prop('status'), lbs);
            return {
                leaderboards
            };
        }
    ),
    withTabs
)(RacesListMobile);

componentService.registerPageComponents({ [CASINO_LEADER_BOARD_RACES_LIST]: RacesList });
